/*
 * Public API Surface of angular-inputs-validation
 */

export * from './lib/angular-inputs-validation.service';
export * from './lib/angular-inputs-validation.component';
export * from './lib/angular-inputs-validation.module';
